import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx'; // Importing xlsx library

const AdminReviewerList = () => {
  const [reviewers, setReviewers] = useState([]);
  const [filteredReviewers, setFilteredReviewers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const defaultFilter = location.state?.defaultFilter || 'all';
  const [filter, setFilter] = useState(defaultFilter);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchReviewers = async () => {
      try {
        const response = await axios.get(`${API}/api/admin/reviewers-filter`, {
          params: { status: filter === 'all' ? '' : filter },
        });
        setReviewers(response.data);
        setTotalPages(Math.ceil(response.data.length / 5)); // Assuming 5 items per page
      } catch (err) {
        console.error(err);
      }
    };
    fetchReviewers();
  }, [filter, API]);

  useEffect(() => {
    const lower = searchTerm.toLowerCase();
    setFilteredReviewers(
      reviewers.filter(
        (r) =>
          r.ReviewerName.toLowerCase().includes(lower) ||
          r.EmailID.toLowerCase().includes(lower)
      )
    );
  }, [searchTerm, reviewers]);

  const handleExportToPDF = () => {
    const doc = new jsPDF();
    doc.text('Reviewers List', 14, 10);
    autoTable(doc, {
      startY: 20,
      head: [['Reviewer Name', 'Email', 'Status']],
      body: reviewers.map((r) => [
        r.ReviewerName,
        r.EmailID,
        r.IsApproved ? 'Approved' : 'Not Approved',
      ]),
      styles: { fontSize: 10, cellPadding: 2 },
      theme: 'grid',
    });
    doc.save('reviewers_list.pdf');
  };

  const handleExportToExcel = () => {
    const data = filteredReviewers.map((r) => ({
      'Reviewer Name': r.ReviewerName,
      'Email': r.EmailID,
      'Status': r.IsApproved ? 'Approved' : 'Not Approved',
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Reviewers');
    XLSX.writeFile(wb, 'reviewers_list.xlsx');
  };

  return (
    <div className="container mt-4">
      <h3>Reviewers List</h3>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by Reviewer Name or Email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label>
          <input
            type="radio"
            name="status"
            value="all"
            checked={filter === 'all'}
            onChange={() => setFilter('all')}
          />{' '}
          All
        </label>
        <label className="ms-2">
          <input
            type="radio"
            name="status"
            value="approved"
            checked={filter === 'approved'}
            onChange={() => setFilter('approved')}
          />{' '}
          Approved
        </label>
        <label className="ms-2">
          <input
            type="radio"
            name="status"
            value="notapproved"
            checked={filter === 'notapproved'}
            onChange={() => setFilter('notapproved')}
          />{' '}
          Not Approved
        </label>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Reviewer Name</th>
            <th>Email</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredReviewers.length > 0 ? (
            filteredReviewers
              .slice((page - 1) * 5, page * 5)
              .map((r) => (
                <tr key={r.ReviewerID}>
                  <td>{r.ReviewerName}</td>
                  <td>{r.EmailID}</td>
                  <td>{r.IsApproved ? 'Approved' : 'Not Approved'}</td>
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                No reviewers found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        >
          Previous
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          className="btn btn-secondary"
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
        >
          Next
        </button>
      </div>

      {filteredReviewers.length > 0 && (
        <div className="mt-3">
          <button className="btn btn-success" onClick={handleExportToPDF}>
            Export to PDF
          </button>
          <button className="btn btn-outline-primary ms-2" onClick={handleExportToExcel}>
            Export to Excel
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminReviewerList;
